import { render, staticRenderFns } from "./WeChatAuthor.vue?vue&type=template&id=060528f6&scoped=true&"
import script from "./WeChatAuthor.vue?vue&type=script&lang=js&"
export * from "./WeChatAuthor.vue?vue&type=script&lang=js&"
import style0 from "./WeChatAuthor.vue?vue&type=style&index=0&id=060528f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060528f6",
  null
  
)

export default component.exports